var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
/**
 * A pagina que explica como excluir a conta pelo app.
 *
 * O passo a passo mora no scope, e nao na view, porque e texto de PRODUTO: quem o
 * revisa e o time, e a view so desenha o que lhe dao. E tambem o que permite
 * verifica-lo em teste sem DOM.
 */
let AppDeleteAccountScope = class AppDeleteAccountScope extends Scope {
    constructor() {
        super(...arguments);
        this.title = 'EXCLUSÃO DE CONTA APP MORMAII + SAÚDE';
        this.subtitle = 'Realize as etapas abaixo no APP Mormaii + Saúde';
        this.steps = [];
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], AppDeleteAccountScope.prototype, "title", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], AppDeleteAccountScope.prototype, "subtitle", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], AppDeleteAccountScope.prototype, "steps", void 0);
AppDeleteAccountScope = __decorate([
    Observable
], AppDeleteAccountScope);
export { AppDeleteAccountScope };
//# sourceMappingURL=app-delete-account.scope.js.map